import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown"]

  connect() {
    this._onClickOutside = (e) => {
      if (!this.element.contains(e.target)) this.close()
    }
    document.addEventListener("click", this._onClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this._onClickOutside)
  }

  toggle() {
    this.dropdownTarget.classList.toggle("ad-card__dropdown--open")
  }

  close() {
    this.dropdownTarget.classList.remove("ad-card__dropdown--open")
  }

  hide() {
    this.element.closest(".ad-card").remove()
  }

  report() {
    this.close()
    alert("Anúncio denunciado. Obrigado pelo feedback.")
  }
}
